import {Validators} from '@angular/forms';

export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const EMAIL_VALIDATORS = [Validators.required, Validators.pattern(EMAIL_PATTERN)];
